import React from 'react';
import {
  AdvisoryBriefDocument,
  DEVELOPMENT_FIRESTORE_GROWTH_STRATEGY_SAMPLE,
  PREPARED_PROVENANCE_GROWTH_STRATEGY_FIXTURE,
} from '../../advisory/composites/ui';
import { AdvisoryCalloutState } from './components/AdvisoryCalloutState';
import type { AdvisoryDemoEnvironment } from './AdvisoryCompetitorAnalysisDemoPage';

const runtimeEnvironment = (): AdvisoryDemoEnvironment => ({
  nodeEnv: process.env.NODE_ENV,
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
});

export const isGrowthStrategyDemoEnabled = (environment: AdvisoryDemoEnvironment): boolean =>
  environment.nodeEnv === 'development' ||
  environment.nodeEnv === 'test' ||
  environment.firebaseProjectId === 'development-477809';

export function AdvisoryGrowthStrategyDemoPage({
  environment = runtimeEnvironment(),
  sample,
}: {
  environment?: AdvisoryDemoEnvironment;
  /** Test seam; browser requests use `?sample=provenance`. */
  sample?: string;
}) {
  if (!isGrowthStrategyDemoEnabled(environment)) {
    return (
      <AdvisoryCalloutState
        tone="info"
        headingKey="advisory:callout.absent.heading"
        bodyKey="advisory:errors.notFound"
      />
    );
  }

  const selectedSample = sample ?? new URLSearchParams(window.location.search).get('sample');
  const model =
    selectedSample === 'provenance'
      ? PREPARED_PROVENANCE_GROWTH_STRATEGY_FIXTURE
      : DEVELOPMENT_FIRESTORE_GROWTH_STRATEGY_SAMPLE;

  return <AdvisoryBriefDocument model={model} />;
}

export default AdvisoryGrowthStrategyDemoPage;
